var _slicedToArray = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _toConsumableArray = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _createClass = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("react-dom/server")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-dom/server"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["react-svg-path"] = {}, e.React, e.ReactDOMServer);
}(this, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  var o = n(t),
    i = n(r);
  function c() {
    return c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, c.apply(this, arguments);
  }
  function s(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function a(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function p(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function h(e, t) {
    return h = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, h(e, t);
  }
  function u(e) {
    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, u(e);
  }
  function l(e, t) {
    if (t && ("object" === u(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return p(e);
  }
  function d(e) {
    return d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, d(e);
  }
  function y(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function f(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  var m = {
    A: {
      args: ["rx", "ry", "rotation", "arc", "sweep", "ex", "ey"]
    },
    a: {
      args: ["rx", "ry", "rotation", "arc", "sweep", "ex", "ey"]
    },
    C: {
      args: ["cx1", "cy1", "cx2", "cy2", "ex", "ey"]
    },
    c: {
      args: ["cx1", "cy1", "cx2", "cy2", "ex", "ey"]
    },
    H: {
      args: ["x"]
    },
    h: {
      args: ["x"]
    },
    L: {
      args: ["x", "y"]
    },
    l: {
      args: ["x", "y"]
    },
    M: {
      args: ["x", "y"]
    },
    m: {
      args: ["x", "y"]
    },
    Q: {
      args: ["cx", "cy", "ex", "ey"]
    },
    q: {
      args: ["cx", "cy", "ex", "ey"]
    },
    S: {
      args: ["cx", "cy", "ex", "ey"]
    },
    s: {
      args: ["cx", "cy", "ex", "ey"]
    },
    T: {
      args: ["ex", "ey"]
    },
    t: {
      args: ["ex", "ey"]
    },
    V: {
      args: ["y"]
    },
    v: {
      args: ["y"]
    },
    z: {
      args: []
    }
  };
  var g = /*#__PURE__*/_createClass(function g() {
    var _this = this;
    _classCallCheck(this, g);
    return f(this, "attr", function (e, t) {
      return _this.attributes[e] = t, _this;
    }), f(this, "fill", function (e) {
      return _this.attr("fill", e);
    }), f(this, "stroke", function (e) {
      return _this.attr("stroke", e);
    }), f(this, "strokeWidth", function (e) {
      return _this.attr("stroke-width", e);
    }), f(this, "style", function (e) {
      return _this.attr("style", e);
    }), f(this, "m", function (e, t) {
      return _this.moveTo(e, t, !0);
    }), f(this, "M", function (e, t) {
      return _this.moveTo(e, t);
    }), f(this, "moveTo", function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return _this.pathData.push("".concat(r ? "m" : "M").concat(e, " ").concat(t)), _this;
    }), f(this, "l", function (e, t) {
      return _this.lineTo(e, t, !0);
    }), f(this, "L", function (e, t) {
      return _this.lineTo(e, t);
    }), f(this, "lineTo", function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return _this.pathData.push("".concat(r ? "l" : "L").concat(e, " ").concat(t)), _this;
    }), f(this, "H", function (e) {
      return _this.horizontalTo(e);
    }), f(this, "h", function (e) {
      return _this.horizontalTo(e, !0);
    }), f(this, "horizontalTo", function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return _this.pathData.push("".concat(t ? "h" : "H").concat(e)), _this;
    }), f(this, "V", function (e) {
      return _this.verticalTo(e);
    }), f(this, "v", function (e) {
      return _this.verticalTo(e, !0);
    }), f(this, "verticalTo", function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return _this.pathData.push("".concat(t ? "v" : "V").concat(e)), _this;
    }), f(this, "Q", function (e, t, r, n) {
      return _this.qCurve(e, t, r, n);
    }), f(this, "q", function (e, t, r, n) {
      return _this.qCurve(e, t, r, n, !0);
    }), f(this, "qCurve", function (e, t, r, n) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      return _this.pathData.push("".concat(o ? "q" : "Q").concat(e, " ").concat(t, " ").concat(r, " ").concat(n)), _this;
    }), f(this, "T", function (e, t) {
      return _this.tCurveTo(e, t);
    }), f(this, "t", function (e, t) {
      return _this.tCurveTo(e, t, !0);
    }), f(this, "tCurveTo", function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return _this.pathData.push("".concat(r ? "t" : "T").concat(e, " ").concat(t)), _this;
    }), f(this, "C", function (e, t, r, n, o, i) {
      return _this.cCurve(e, t, r, n, o, i);
    }), f(this, "c", function (e, t, r, n, o, i) {
      return _this.cCurve(e, t, r, n, o, i, !0);
    }), f(this, "cCurve", function (e, t, r, n, o, i) {
      var c = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
      return _this.pathData.push("".concat(c ? "c" : "C").concat(e, " ").concat(t, " ").concat(r, " ").concat(n, " ").concat(o, " ").concat(i)), _this;
    }), f(this, "S", function (e, t, r, n) {
      return _this.sCurveTo(e, t, r, n);
    }), f(this, "s", function (e, t, r, n) {
      return _this.sCurveTo(e, t, r, n, !0);
    }), f(this, "sCurveTo", function (e, t, r, n) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      return _this.pathData.push("".concat(o ? "s" : "S").concat(e, " ").concat(t, " ").concat(r, " ").concat(n)), _this;
    }), f(this, "A", function (e, t, r, n, o, i, c) {
      return _this.arc(e, t, r, n, o, i, c);
    }), f(this, "a", function (e, t, r, n, o, i, c) {
      return _this.arc(e, t, r, n, o, i, c, !0);
    }), f(this, "arc", function (e, t, r, n, o, i, c) {
      var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
      return _this.pathData.push("".concat(s ? "a" : "A").concat(e, " ").concat(t, " ").concat(r, " ").concat(n, " ").concat(o, " ").concat(i, " ").concat(c)), _this;
    }), f(this, "down", function (e) {
      return _this.v(e);
    }), f(this, "up", function (e) {
      return _this.v(-1 * e);
    }), f(this, "right", function (e) {
      return _this.h(e);
    }), f(this, "left", function (e) {
      return _this.h(-1 * e);
    }), f(this, "close", function () {
      return _this.pathData.push("z"), _this;
    }), f(this, "toArray", function () {
      return _this.pathData;
    }), f(this, "toString", function () {
      return _this.pathData.join("");
    }), f(this, "toCommands", function () {
      return _this.pathData.map(function (e) {
        var t = [e.substr(0, 1)],
          r = e.substr(1);
        return r.length && t.push.apply(t, _toConsumableArray(r.split(" ").map(Number))), t;
      });
    }), f(this, "toAnnotatedCommands", function () {
      return _this.toCommands().map(function (e) {
        var t = e.shift(),
          r = m[t].args;
        return r.length ? {
          fn: t,
          args: e.reduce(function (e, t, n) {
            return e[r[n]] = t, e;
          }, {})
        } : {
          fn: t
        };
      });
    }), f(this, "toElement", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = _objectSpread(_objectSpread({}, _this.attributes), e),
        r = document.createElementNS("http://www.w3.org/2000/svg", "path");
      return Object.keys(t).forEach(function (e) {
        r.setAttribute(e, t[e]);
      }), r.setAttribute("d", _this.toString()), r;
    }), this.pathData = [], this.attributes = {}, this;
  });
  function b(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var r,
        n = d(e);
      if (t) {
        var o = d(this).constructor;
        r = Reflect.construct(n, arguments, o);
      } else r = n.apply(this, arguments);
      return l(this, r);
    };
  }
  f(g, "angleInRadians", function (e) {
    return e * Math.PI / 180;
  }), f(g, "polarToCartesian", function (e, t, r, n) {
    var o = g.angleInRadians(n);
    return {
      x: e + r * Math.cos(o),
      y: t + r * Math.sin(o)
    };
  }), f(g, "clockwisePoint", function (e, t, r, n) {
    var o = n - 90;
    return g.polarToCartesian(e, t, r, o);
  }), f(g, "radialPoints", function (e, t, r, n, o) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    o = o || -.5 * Math.PI, e = e || 1e-10;
    var c = 2 * Math.PI * i / n,
      s = Array.from(Array(n >= 0 ? n : 0).keys()),
      a = Math.max(0, 4 - Math.floor(Math.log10(e)));
    return s.map(function (n, i) {
      var s = i * c + o;
      return [(t + e * Math.cos(s)).toFixed(a), (r + e * Math.sin(s)).toFixed(a)];
    });
  }), f(g, "positionByArray", function (e, t, r, n) {
    var o = [],
      i = e / 2;
    return t.forEach(function (t, c) {
      t.forEach(function (t, s) {
        t && o.push({
          size: e,
          cx: s * e + i + r,
          cy: c * e + i + n,
          ri: c,
          ci: s,
          value: t
        });
      });
    }), o;
  }), f(g, "macro", function (e, t) {
    g.prototype[e] = t;
  }), g.macro("rect", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    return this.M(r - e / 2, n - t / 2).right(e).down(t).left(e).up(t), o && this.M(r, n), this;
  }), g.macro("square", function (e, t, r) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    return this.rect(e, e, t, r, n);
  }), g.macro("roundedSquare", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    return this.roundedRect(e, e, t, r, n, o);
  }), g.macro("roundedRect", function (e, t, r, n, o) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var c = o - t / 2,
      s = n - e / 2,
      a = s + e,
      p = c + t;
    var h = Math.min(r, e / 2);
    h = h < 0 ? 0 : h;
    var u = Math.min(r, t / 2);
    u = u < 0 ? 0 : u;
    var l = Math.max(e - 2 * h, 0),
      d = Math.max(t - 2 * u, 0);
    return this.M(s + h, c).right(l).A(h, u, 0, 0, 1, a, c + u).down(d).A(h, u, 0, 0, 1, a - h, p).left(l).A(h, u, 0, 0, 1, s, p - u).up(d).A(h, u, 0, 0, 1, s + h, c).M(s, c), i && this.M(n, o), this;
  }), g.macro("circle", function (e, t, r) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    return this.ellipse(e, e, t, r, n);
  }), g.macro("ellipse", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var i = e / 2,
      c = t / 2;
    return this.M(r + i, n).A(i, c, 0, 0, 1, r - i, n).A(i, c, 0, 0, 1, r + i, n).close(), o && this.M(r, n), this;
  }), g.macro("kite", function (e, t, r, n, o) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    r = r || parseInt(.33 * t, 10);
    var _this$constructor$rad = this.constructor.radialPoints(t / 2, n, o, 4),
      _this$constructor$rad2 = _slicedToArray(_this$constructor$rad, 3),
      c = _this$constructor$rad2[0],
      s = _this$constructor$rad2[1],
      a = _this$constructor$rad2[2],
      p = parseInt(c[1], 10) + r,
      h = [c, [n - e / 2, p], a, [n + e / 2, p]];
    return this.polyline(h).close();
  }), g.macro("lens", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    return this.M(r - e / 2, n).Q(r, n - t, r + e / 2, n).Q(r, n + t, r - e / 2, n), o && this.M(r, n), this;
  }), g.macro("polyline", function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var r = _toConsumableArray(e),
      n = r.shift(),
      o = t ? this.m : this.M,
      i = t ? this.l : this.L;
    return o.apply(null, n), r.forEach(function (e) {
      i.apply(null, e);
    }), this;
  }), g.macro("polygon", function (e) {
    return this.polyline(e).close(), this;
  }), g.macro("regPolygon", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    return this.polygon(this.constructor.radialPoints(e / 2, r, n, t)), o && this.M(r, n), this;
  }), g.macro("polygram", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    return this.polygon(this.constructor.radialPoints(e / 2, r, n, t, null, o)), i && this.M(r, n), this;
  }), g.macro("radialLines", function (e, t, r, n, o) {
    var _this2 = this;
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var c = this.constructor.radialPoints(t / 2, n, o, r),
      s = this.constructor.radialPoints(e / 2, n, o, r);
    return c.forEach(function (e, t) {
      _this2.M(e[0], e[1]).L(s[t][0], s[t][1]);
    }), i && this.M(n, o), this;
  }), g.macro("star", function (e, t, r, n, o) {
    var _this3 = this;
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var c = t / 2,
      s = e / 2,
      a = 360 / (2 * r),
      p = Array.from({
        length: 2 * r
      }).map(function (e, t) {
        var r = t % 2 == 0 ? s : c,
          p = a * t;
        var _this3$constructor$cl = _this3.constructor.clockwisePoint(n, o, r, p, i),
          h = _this3$constructor$cl.x,
          u = _this3$constructor$cl.y;
        return [h, u];
      });
    return this.polygon(p), i && this.M(n, o), this;
  }), g.macro("triangle", function (e, t, r) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    var o = Math.sqrt(3),
      i = [t, r - o / 3 * e],
      c = [t - e / 2, r + o / 6 * e],
      s = [t + e / 2, r + o / 6 * e];
    return this.polygon([i, c, s]), n && this.M(t, r), this;
  }), g.macro("sector", function (e, t, r, n, o) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var c = r / 2,
      s = this.constructor.clockwisePoint(e, t, c, o),
      a = this.constructor.clockwisePoint(e, t, c, n),
      p = o - n <= 180 ? 0 : 1;
    return this.M(s.x, s.y).A(c, c, 0, p, 0, a.x, a.y).L(e, t).L(s.x, s.y), i && this.M(e, t), this;
  }), g.macro("segment", function (e, t, r, n, o) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var c = r / 2,
      s = this.constructor.clockwisePoint(e, t, c, o),
      a = this.constructor.clockwisePoint(e, t, c, n),
      p = o - n <= 180 ? 0 : 1;
    return this.M(s.x, s.y).A(c, c, 0, p, 0, a.x, a.y), i && this.M(e, t), this;
  }), g.macro("cross", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var i = r - e / 2,
      c = i + e,
      s = n - t / 2,
      a = s + t;
    return this.M(i, n).L(c, n).M(r, a).L(r, s), o && this.M(r, n), this;
  }), g.macro("symH", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var i = r - e / 2,
      c = i + e,
      s = n - t / 2,
      a = s + t;
    return this.M(i, s).L(i, a).M(i, n).L(c, n).M(c, s).L(c, a), o && this.M(r, n), this;
  }), g.macro("symI", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var i = r - e / 2,
      c = i + e,
      s = n - t / 2,
      a = s + t;
    return this.M(i, s).L(c, s).M(r, s).L(r, a).M(i, a).L(c, a), o && this.M(r, n), this;
  }), g.macro("symX", function (e, t, r, n) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var i = r - e / 2,
      c = i + e,
      s = n - t / 2,
      a = s + t;
    return this.M(i, s).L(c, a).M(i, a).L(c, s), o && this.M(r, n), this;
  }), g.macro("omino", function (e, t, r, n) {
    var _this4 = this;
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
    return this.constructor.positionByArray(e, t, r, n).forEach(function (e, t, r) {
      var n = e.cx,
        i = e.cy,
        c = e.ri,
        s = e.ci,
        a = e.size,
        p = a / 2,
        h = r.find(function (e) {
          return e.ri === c && e.ci === s - 1;
        }),
        u = r.find(function (e) {
          return e.ri === c && e.ci === s + 1;
        }),
        l = r.find(function (e) {
          return e.ri === c - 1 && e.ci === s;
        }),
        d = r.find(function (e) {
          return e.ri === c + 1 && e.ci === s;
        }),
        y = n - p,
        f = n + p,
        m = i - p,
        g = i + p;
      h && !o || (_this4.M(y, m), _this4.v(a)), u || (_this4.M(f, m), _this4.v(a)), l && !o || (_this4.M(y, m), _this4.h(a)), d || (_this4.M(y, g), _this4.h(a));
    }), this;
  });
  var x = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && h(e, t);
    }(u, e);
    var t,
      r,
      n,
      i = b(u);
    function u() {
      var e;
      s(this, u);
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
      return y(p(e = i.call.apply(i, [this].concat(r))), "strokeWidth", function (t) {
        return e.attr("strokeWidth", t);
      }), e;
    }
    return t = u, r = [{
      key: "toComponent",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return o.default.createElement("path", c({
          d: this.toString()
        }, this.attributes, e));
      }
    }], r && a(t.prototype, r), n && a(t, n), Object.defineProperty(t, "prototype", {
      writable: !1
    }), u;
  }(g);
  function v(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function O(e, t) {
    if (e) {
      if ("string" == typeof e) return v(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e, t) : void 0;
    }
  }
  function w(e) {
    return function (e) {
      if (Array.isArray(e)) return v(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || O(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function P(e, t) {
    if (null == e) return {};
    var r,
      n,
      o = function (e, t) {
        if (null == e) return {};
        var r,
          n,
          o = {},
          i = Object.keys(e);
        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        return o;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
  }
  var j = ["attach", "ox", "oy"];
  function S(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function E(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? S(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  function k(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function C(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? k(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var D = function D(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        r = C({}, e),
        n = ["sx", "sy", "cx", "cy", "oy", "ox", "ex", "ey"].concat(w(t));
      return n.forEach(function (e) {
        return delete r[e];
      }), r;
    },
    M = ["merge", "attach"];
  function T(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function R(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? T(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var A = function A(e) {
    var t = e.pathMethod,
      r = e.attributes,
      n = e.ex,
      i = e.ey,
      c = e.sx,
      s = e.sy,
      a = e.children,
      p = r.merge;
    r.attach;
    var h = P(r, M),
      u = p ? "toString" : "toComponent",
      l = D(h);
    return a ? [t ? t()[u](R(R({}, l), {}, {
      key: -1
    })) : null, o.default.Children.map(a, function (e, t) {
      return e && o.default.cloneElement(e, R({
        key: t,
        merge: p
      }, function (e, t, r, n, o) {
        var i = e.attach,
          c = void 0 === i ? "end" : i,
          s = e.ox,
          a = void 0 === s ? 0 : s,
          p = e.oy,
          h = void 0 === p ? 0 : p,
          u = P(e, j);
        return E("start" === c ? {
          sx: t + a,
          sy: r + h,
          cx: t + a,
          cy: r + h
        } : {
          sx: n + a,
          sy: o + h,
          cx: n + a,
          cy: o + h
        }, u);
      }(e.props, n, i, c, s)));
    }).filter(function (e) {
      return e;
    })] : t ? t()[u](l) : null;
  };
  function q(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function L(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? q(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var z = function z(e, t) {
    var r = e.args,
      n = e.command,
      o = e.props,
      i = e.nestingProps,
      c = function (e, t, r) {
        var n = {},
          o = [];
        return {
          result: Object.keys(r).every(function (i) {
            var c = e.hasOwnProperty(i);
            if (!r[i].isRequired && !c) return "boolean" !== r[i].type && (n[i] = void 0 !== t.props[i].default ? r[i].default : null), !0;
            if (c && "boolean" === r[i].type) return !0 === e[i] || !1 === e[i];
            if (r[i].isRequired && !c) return r[i].hasOwnProperty("default") ? (n[i] = t.props[i].default, !0) : (o.push("Required ".concat(i, " prop is missing in ").concat(t.Component, ".")), !1);
            var s = r[i].validator(e[i]);
            return s || o.push("".concat(i, " prop is invalid in ").concat(t.Component, ".")), c && s;
          }),
          augment: n,
          msg: o
        };
      }(t, e, o),
      s = c.result,
      a = c.msg,
      p = c.augment;
    if (!s) throw a.forEach(function (e) {
      return console.error(e);
    }), new Error("".concat(a.join(",")));
    var h,
      u,
      l = L(L({}, t), p),
      d = r.map(function (e) {
        return l[e];
      }),
      f = l.children,
      m = D(L({}, l), [].concat(w(Object.keys(o)), ["children"]));
    h = "function" == typeof i ? i(l) : Object.keys(i).reduce(function (e, r) {
      return L(L({}, e), {}, y({}, r, t[i[r]]));
    }, {});
    var g,
      b = new x();
    if (e.preCommand) {
      var v = e.preArgs.map(function (e) {
        return l[e];
      });
      b[e.preCommand].apply(b, v);
    }
    if (e.postCommand) {
      var O = e.postCommand,
        P = l.hasOwnProperty(O),
        j = l.hasOwnProperty(O.toUpperCase());
      (P || j) && (u = function u() {
        b[n].apply(b, d);
        var e = l[O],
          t = l[O.toUpperCase()];
        return P && e && e.length && e.forEach(function (e) {
          return b[O].apply(b, e);
        }), j && t && t.length && t.forEach(function (e) {
          return b[O.toUpperCase()].apply(b, e);
        }), b;
      });
    }
    u || (u = (g = b[n]).bind.apply(g, [b].concat(w(d))));
    return A(L(L({
      pathMethod: u,
      attributes: m
    }, h), {}, {
      children: f
    }));
  };
  function $(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != r) {
        var n,
          o,
          i = [],
          c = !0,
          s = !1;
        try {
          for (r = r.call(e); !(c = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); c = !0);
        } catch (e) {
          s = !0, o = e;
        } finally {
          try {
            c || null == r.return || r.return();
          } finally {
            if (s) throw o;
          }
        }
        return i;
      }
    }(e, t) || O(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function I(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function H(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? I(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var W = function W(e) {
      return !isNaN(e);
    },
    N = function N(e) {
      try {
        if (!(e instanceof Array) || !e.length || e.some(function (e) {
          return !(e instanceof Array);
        })) throw new Error("bad points, bad!.");
        return e.every(function (e) {
          return e.every(function (e) {
            return !isNaN(e);
          });
        });
      } catch (e) {
        return e.message;
      }
    },
    X = {
      ex: "cx",
      ey: "cy",
      sx: "cx",
      sy: "cy"
    },
    Q = {
      type: "number",
      isRequired: !0,
      validator: W
    },
    _ = H(H({}, Q), {}, {
      description: "Center x coordinate of the shape."
    }),
    U = H(H({}, Q), {}, {
      description: "Center x coordinate of the shape."
    }),
    B = {
      sxy: H(H({}, Q), {}, {
        isRequired: !1,
        default: null,
        k: "sxy",
        p: ["sx", "sy"],
        description: 'If sx and sy are equal values you can use the shortcut "sxy" to set both at once.'
      }),
      exy: H(H({}, Q), {}, {
        isRequired: !1,
        default: null,
        k: "exy",
        p: ["ex", "ey"],
        description: 'If ex and ey are equal values you can use the shortcut "exy" to set both at once.'
      }),
      cxy: H(H({}, Q), {}, {
        isRequired: !1,
        default: null,
        k: "cxy",
        p: ["cx", "cy"],
        description: 'If cx and cy are equal values you can use the shortcut "cxy" to set both at once.'
      }),
      rxy: H(H({}, Q), {}, {
        isRequired: !1,
        default: null,
        k: "rxy",
        p: ["rx", "ry"],
        description: 'If rx and ry are equal values you can use the shortcut "rxy" to set both at once.'
      })
    },
    Y = {
      default: !0,
      type: "boolean",
      isRequired: !1,
      description: "Determines whether cursor should return to cx & cy as a last step."
    },
    F = {
      circle: {
        category: "basicShapes",
        Component: "Circle",
        command: "circle",
        args: ["size", "cx", "cy", "centerEnd"],
        description: "Circle is drawn from center points (cx & cy). The cursor is then moved to the center points.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Circumference of the Circle."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      ellipse: {
        category: "basicShapes",
        Component: "Ellipse",
        command: "ellipse",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "Ellipse is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Ellipse."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Ellipse."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      kite: {
        category: "basicShapes",
        Component: "Kite",
        command: "kite",
        args: ["width", "height", "dh", "cx", "cy", "centerEnd"],
        description: ".kite is drawn from center point (cx & cy). dh = position of the left & right points from the top of the shape. The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Kite."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Kite."
          }),
          dh: H(H({}, Q), {}, {
            description: "Vertical position of the left and right points from the top."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      lens: {
        category: "basicShapes",
        Component: "Lens",
        command: "lens",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "Lens is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Lens."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Lens."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      omino: {
        category: "basicShapes",
        Component: "Omino",
        command: "omino",
        args: ["size", "shape", "sx", "sy", "lined"],
        description: "Omino is drawn based on the positive values positioned in an 2d array. Think Tetris pieces.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Size of the squares."
          }),
          shape: {
            type: "2d-array",
            isRequired: !0,
            validator: function validator(e) {
              try {
                if (!(e instanceof Array) || !e.length || e.some(function (e) {
                  return !(e instanceof Array);
                })) throw new Error("not a 2s array, bad!.");
                return e.every(function (e) {
                  return e instanceof Array;
                });
              } catch (e) {
                return e.message;
              }
            },
            description: "2d array of the shape."
          },
          sx: H(H({}, Q), {}, {
            description: "Starting x coordinate for left."
          }),
          sy: H(H({}, Q), {}, {
            description: "Starting y coordinate for top."
          }),
          lined: {
            default: !1,
            type: "boolean",
            isRequired: !1,
            description: "Draw inner lines or not."
          }
        },
        shorthands: [B.sxy],
        nestingProps: function nestingProps(e) {
          var t = e.sx,
            r = e.sy;
          return {
            ex: t,
            ey: r,
            sx: t,
            sy: r
          };
        }
      },
      polygon: {
        category: "basicShapes",
        Component: "Polygon",
        command: "polygon",
        args: ["points"],
        description: "Polygon accepts an array of [x, y] coordinates and then draws lines connecting those points.  The path will start from the first point and end on the first point - closing the shape.",
        props: {
          points: {
            type: "point-array",
            pointsLength: 2,
            isRequired: !0,
            validator: N,
            description: "x, y, points of the polygon."
          }
        },
        nestingProps: function nestingProps(e) {
          var t = e.points,
            r = $(t[0], 2),
            n = r[0],
            o = r[1],
            i = $(t[t.length - 1], 2);
          return {
            ex: n,
            ey: o,
            sx: i[0],
            sy: i[1]
          };
        }
      },
      polygram: {
        category: "basicShapes",
        Component: "Polygram",
        command: "polygram",
        args: ["size", "points", "cx", "cy", "vertexSkip", "centerEnd"],
        description: "Polygram is drawn from center point (cx & cy). The first outer point of the shape will always be at top center. The cursor is then moved to the center point.  Skipping a vertex is what makes a polygram appear as intersecting lines, a vertexSkip of 1 will result in a regular polygon.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Size of the underlying polygon."
          }),
          points: H(H({}, Q), {}, {
            description: "Number of points to create."
          }),
          cx: _,
          cy: U,
          vertexSkip: H(H({}, Q), {}, {
            isRequired: !1,
            default: 2,
            description: "Integer representing which vertex to go to next relative to current."
          }),
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      polyline: {
        category: "basicShapes",
        Component: "Polyline",
        command: "polyline",
        args: ["points", "relative"],
        description: "Polyline accepts an array of [x, y] coordinates and then draws lines connecting those points.  The path will start from the first point and end on the last.  points can be absolute or relative.",
        props: {
          points: {
            type: "point-array",
            pointsLength: 2,
            isRequired: !0,
            validator: N,
            description: "x, y, points of the Polyline."
          },
          relative: {
            type: "boolean",
            isRequired: !1,
            default: !1,
            description: "If set to true all points will be relative."
          }
        },
        nestingProps: function nestingProps(e) {
          var t = e.points,
            r = $(t[0], 2),
            n = r[0],
            o = r[1],
            i = $(t[t.length - 1], 2);
          return {
            ex: n,
            ey: o,
            sx: i[0],
            sy: i[1]
          };
        }
      },
      line: {
        category: "basicShapes",
        Component: "Line",
        command: "lineTo",
        args: ["ex", "ey", "relative"],
        preCommand: "moveTo",
        preArgs: ["sx", "sy"],
        description: "Line is drawn from starting points (sx & sy) to ending points (ex & ey). sx (starting x) & sy (starting y) will always be absolutely positioned, however with relative=true the ex and ey points can relative to sx & sy.",
        props: {
          sx: H(H({}, Q), {}, {
            description: "Starting x coordinate for the Line."
          }),
          sy: H(H({}, Q), {}, {
            description: "Starting y coordinate for the Line."
          }),
          ex: H(H({}, Q), {}, {
            description: "Ending x coordinate for the Line."
          }),
          ey: H(H({}, Q), {}, {
            description: "Ending y coordinate for the Line."
          }),
          relative: {
            type: "boolean",
            default: !1,
            isRequired: !0,
            description: "If set to true ex & ey will become relative to sx & sy."
          }
        },
        nestingProps: function nestingProps(e) {
          return {
            ex: e.sx,
            ey: e.sy,
            sx: e.ex,
            sy: e.ey
          };
        },
        shorthands: [B.exy, B.sxy]
      },
      radialLines: {
        category: "basicShapes",
        Component: "RadialLines",
        command: "radialLines",
        args: ["outerSize", "innerSize", "points", "cx", "cy", "centerEnd"],
        description: "RadialLines is drawn from center point (cx & cy). The first outer point of the shape will always be at top center. The cursor is then moved to the center point.",
        props: {
          outerSize: H(H({}, Q), {}, {
            description: "Circumference of the outer circle."
          }),
          innerSize: H(H({}, Q), {}, {
            description: "Circumference of the inner circle."
          }),
          points: H(H({}, Q), {}, {
            description: "Number of lines to draw."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      rect: {
        category: "basicShapes",
        Component: "Rect",
        command: "rect",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "Rect is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Rect."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Rect."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      roundedRect: {
        category: "basicShapes",
        Component: "RoundedRect",
        command: "roundedRect",
        args: ["width", "height", "radius", "cx", "cy", "centerEnd"],
        description: "Rect is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Rect."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Rect."
          }),
          radius: H(H({}, Q), {}, {
            description: "Radius for the corners."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      regPolygon: {
        category: "basicShapes",
        Component: "RegPolygon",
        command: "regPolygon",
        args: ["size", "sides", "cx", "cy", "centerEnd"],
        description: "RegPolygon is drawn from center point (cx & cy). The first outer point of the shape will always be at top center. The cursor is then moved to the center point.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Size of the RegPolygon."
          }),
          sides: H(H({}, Q), {}, {
            description: "Number of sides of the RegPolygon."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      sector: {
        category: "basicShapes",
        Component: "Sector",
        command: "sector",
        args: ["cx", "cy", "size", "startAngle", "endAngle", "centerEnd"],
        description: "Sector is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          cx: _,
          cy: U,
          size: H(H({}, Q), {}, {
            description: "Circumference of the Sector."
          }),
          startAngle: H(H({}, Q), {}, {
            description: "Start angle of the Sector.  0 = top center."
          }),
          endAngle: H(H({}, Q), {}, {
            description: "End angle of the Sector.  0 = top center."
          }),
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      segment: {
        category: "basicShapes",
        Component: "Segment",
        command: "segment",
        args: ["cx", "cy", "size", "startAngle", "endAngle", "centerEnd"],
        description: "Segment is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          cx: _,
          cy: U,
          size: H(H({}, Q), {}, {
            description: "Circumference of the Segment."
          }),
          startAngle: H(H({}, Q), {}, {
            description: "Start angle of the Segment.  0 = top center."
          }),
          endAngle: H(H({}, Q), {}, {
            description: "End angle of the Segment.  0 = top center."
          }),
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      square: {
        category: "basicShapes",
        Component: "Square",
        command: "square",
        args: ["size", "cx", "cy", "centerEnd"],
        description: "Square is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Width &  height of the Square."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      roundedSquare: {
        category: "basicShapes",
        Component: "RoundedSquare",
        command: "roundedSquare",
        args: ["size", "radius", "cx", "cy", "centerEnd"],
        description: "RoundedSquare is drawn from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Width &  height of the Square."
          }),
          radius: H(H({}, Q), {}, {
            description: "Radius for the corners."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      star: {
        category: "basicShapes",
        Component: "Star",
        command: "star",
        args: ["outerSize", "innerSize", "points", "cx", "cy", "centerEnd"],
        description: "Star is drawn from center point (cx & cy). The first outer point of the shape will always be at top center. The cursor is then moved to the center point.",
        props: {
          outerSize: H(H({}, Q), {}, {
            description: "The outer circumference where points will reach."
          }),
          innerSize: H(H({}, Q), {}, {
            description: "The inner circumference where points will end."
          }),
          points: H(H({}, Q), {}, {
            description: "Number of points for the Star."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      triangle: {
        category: "basicShapes",
        Component: "Triangle",
        command: "triangle",
        args: ["size", "cx", "cy", "centerEnd"],
        description: "Triangle draws an equilateral triangle from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          size: H(H({}, Q), {}, {
            description: "Size of the Tirangle."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      symX: {
        category: "basicShapes",
        Component: "SymX",
        command: "symX",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "SymX draws an X shape from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the X."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the X."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      symI: {
        category: "basicShapes",
        Component: "SymI",
        command: "symI",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "SymI draws an I shape from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the I."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the I."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      symH: {
        category: "basicShapes",
        Component: "SymH",
        command: "symH",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: "SymH draws an H shape from center point (cx & cy). The cursor is then moved to the center point.",
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the H."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the H."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      cross: {
        category: "basicShapes",
        Component: "Cross",
        command: "cross",
        args: ["width", "height", "cx", "cy", "centerEnd"],
        description: 'Cross draws an "cross" shape from center point (cx & cy). The cursor is then moved to the center point.',
        props: {
          width: H(H({}, Q), {}, {
            description: "Width of the Cross."
          }),
          height: H(H({}, Q), {}, {
            description: "Height of the Cross."
          }),
          cx: _,
          cy: U,
          centerEnd: Y
        },
        nestingProps: X,
        shorthands: [B.cxy]
      },
      arc: {
        category: "curves",
        Component: "Arc",
        command: "arc",
        args: ["rx", "ry", "rotation", "arc", "sweep", "ex", "ey", "relative"],
        preCommand: "moveTo",
        preArgs: ["sx", "sy"],
        description: "An Arc segment draws a segment of an ellipse.",
        props: {
          sx: H(H({}, Q), {}, {
            description: "Starting x coordinate for the Arc."
          }),
          sy: H(H({}, Q), {}, {
            description: "Starting y coordinate for the Arc."
          }),
          rx: H(H({}, Q), {}, {
            description: "Width of the underlying ellipse of the Arc."
          }),
          ry: H(H({}, Q), {}, {
            description: "Height of the underlying ellipse of the Arc."
          }),
          rotation: {
            type: "number",
            validator: W,
            default: 0,
            isRequired: !1,
            description: "Rotation of the underlying ellipse of the Arc."
          },
          arc: {
            type: "number",
            validator: W,
            default: 0,
            isRequired: !1,
            description: "Large arc flag: this says whether to follow the larger or smaller part of the underlying ellipse."
          },
          sweep: {
            type: "number",
            validator: W,
            default: 0,
            isRequired: !1,
            description: "Sweep flag: think of this as direction flag, follow a clockwise or counterclockwise path along the underlying ellipse."
          },
          ex: H(H({}, Q), {}, {
            description: "Ending x coordinate for the Arc."
          }),
          ey: H(H({}, Q), {}, {
            description: "Ending y coordinate for the Arc."
          }),
          relative: {
            type: "boolean",
            default: !1,
            isRequired: !1,
            description: "If set to true all points after sx & sy will become relative to sx & sy."
          }
        },
        nestingProps: function nestingProps(e) {
          return {
            ex: e.sx,
            ey: e.sy,
            sx: e.ex,
            sy: e.ey
          };
        },
        shorthands: [B.exy, B.sxy, B.rxy]
      },
      cubic: {
        category: "curves",
        Component: "Cubic",
        command: "cCurve",
        args: ["cx1", "cy1", "cx2", "cy2", "ex", "ey"],
        preCommand: "moveTo",
        preArgs: ["sx", "sy"],
        postCommand: "s",
        description: "Cubic is drawn from an sx and sy to an ex and ey with two control points (cx1+cy1 & cx2+cy2).",
        props: {
          sx: H(H({}, Q), {}, {
            description: "Starting x coordinate for the Cubic."
          }),
          sy: H(H({}, Q), {}, {
            description: "Starting y coordinate for the Cubic."
          }),
          cx1: H(H({}, Q), {}, {
            description: "x coordinate for control point 1."
          }),
          cy1: H(H({}, Q), {}, {
            description: "y coordinate for control point 1."
          }),
          cx2: H(H({}, Q), {}, {
            description: "x coordinate for control point 2."
          }),
          cy2: H(H({}, Q), {}, {
            description: "y coordinate for control point 2."
          }),
          ex: H(H({}, Q), {}, {
            description: "Ending x coordinate for the Cubic."
          }),
          ey: H(H({}, Q), {}, {
            description: "Ending y coordinate for the Cubic."
          }),
          S: {
            type: "point-array",
            pointsLength: 4,
            validator: N,
            isRequired: !1,
            description: "Optionally String together multiple Cubic wit an array consisting of 2 or more control points."
          },
          s: {
            type: "point-array",
            pointsLength: 4,
            validator: N,
            isRequired: !1,
            description: 'Optional relative "smoooth curve" array consisting of 2 or more control points.'
          },
          relative: {
            type: "boolean",
            default: !1,
            isRequired: !1,
            description: "If set to true all points after sx & sy will become relative to sx & sy."
          }
        },
        nestingProps: function nestingProps(e) {
          var t = e.sx,
            r = e.sy,
            n = e.ex,
            o = e.ey,
            i = e.S,
            c = n,
            s = o;
          return i && i.length && (c = i[i.length - 1][0], s = i[i.length - 1][1]), {
            ex: t,
            ey: r,
            sx: c,
            sy: s
          };
        },
        shorthands: [B.exy, B.sxy]
      },
      quad: {
        category: "curves",
        Component: "Quad",
        command: "qCurve",
        args: ["cx", "cy", "ex", "ey"],
        preCommand: "moveTo",
        preArgs: ["sx", "sy"],
        postCommand: "t",
        description: "Quad is drawn from an sx and sy to an ex and ey with one control points (cx & cy).",
        props: {
          sx: H(H({}, Q), {}, {
            description: "Starting x coordinate for the Quad."
          }),
          sy: H(H({}, Q), {}, {
            description: "Starting y coordinate for the Quad."
          }),
          cx: H(H({}, Q), {}, {
            description: "x coordinate for the control point."
          }),
          cy: H(H({}, Q), {}, {
            description: "y coordinate for the control point."
          }),
          ex: H(H({}, Q), {}, {
            description: "Ending x coordinate for the Quad."
          }),
          ey: H(H({}, Q), {}, {
            description: "Ending y coordinate for the Quad."
          }),
          T: {
            type: "point-array",
            pointsLength: 2,
            validator: N,
            isRequired: !1,
            description: "String together multiple Quad curves."
          },
          t: {
            type: "point-array",
            pointsLength: 2,
            validator: N,
            isRequired: !1,
            description: "String together multiple Quad curves where coordinates are relative."
          },
          relative: {
            type: "boolean",
            default: !1,
            isRequired: !1,
            description: "If set to true all points after sx & sy will become relative to sx & sy."
          }
        },
        nestingProps: function nestingProps(e) {
          var t = e.sx,
            r = e.sy,
            n = e.ex,
            o = e.ey,
            i = e.T,
            c = n,
            s = o;
          return i && i.length && (c = i[i.length - 1][0], s = i[i.length - 1][1]), {
            ex: t,
            ey: r,
            sx: c,
            sy: s
          };
        },
        shorthands: [B.exy, B.sxy, B.cxy]
      }
    };
  function K(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  Object.keys(F).filter(function (e) {
    return "basicShapes" === F[e].category;
  }).reduce(function (e, t) {
    return H(H({}, e), {}, y({}, t, F[t]));
  }, {}), Object.keys(F).filter(function (e) {
    return "curves" === F[e].category;
  }).reduce(function (e, t) {
    return H(H({}, e), {}, y({}, t, F[t]));
  }, {});
  var V = function V(e) {
      var t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? K(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({}, e);
      return Object.values(B).forEach(function (e) {
        if (t.hasOwnProperty(e.k)) {
          if (isNaN(t[e.k])) throw new Error("".concat(e.k, " isNaN."));
          e.p.forEach(function (r) {
            t[r] = t[e.k];
          }), delete t[e.k];
        }
      }), t;
    },
    G = Object.keys(F).reduce(function (e, t) {
      var r = function r(e) {
        var r = e ? V(e) : e;
        return z(F[t], r);
      };
      return r.displayName = F[t].Component, e[F[t].Component] = r, e;
    }, {}),
    J = G.Circle,
    Z = G.Kite,
    ee = G.Ellipse,
    te = G.Lens,
    re = G.Polygon,
    ne = G.Polygram,
    oe = G.Polyline,
    ie = G.RadialLines,
    ce = G.Rect,
    se = G.RegPolygon,
    ae = G.Sector,
    pe = G.Segment,
    he = G.Square,
    ue = G.Star,
    le = G.Triangle,
    de = G.Line,
    ye = G.Arc,
    fe = G.Cubic,
    me = G.Quad,
    ge = G.Cross,
    be = G.SymX,
    xe = G.SymH,
    ve = G.SymI,
    Oe = G.RoundedRect,
    we = G.RoundedSquare,
    Pe = G.Omino,
    je = ["x", "y", "sx", "sy", "children"],
    Se = function Se(e) {
      var t = e.x,
        r = e.y,
        n = e.sx,
        i = e.sy,
        s = e.children,
        a = P(e, je),
        p = D(a);
      return o.default.createElement("text", c({
        x: n || t,
        y: i || r
      }, p), s);
    },
    Ee = ["children", "sx", "sy", "cx", "cy", "ex", "ey"];
  function ke(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var Ce = ["children", "x", "y", "sx", "sy", "cx", "cy", "width", "height", "scale"];
  function De(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Me(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? De(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : De(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var Te = function Te(e) {
    var t = e.children,
      r = e.x,
      n = e.y,
      i = e.sx,
      s = e.sy;
    e.cx, e.cy;
    var a = e.width,
      p = void 0 === a ? 0 : a,
      h = e.height,
      u = void 0 === h ? 0 : h,
      l = e.scale,
      d = void 0 !== l && l,
      y = P(e, Ce),
      f = Me({
        preserveAspectRatio: "xMinYMin meet"
      }, y);
    f.style = Me({
      width: "100%",
      height: "auto",
      maxWidth: p,
      maxHeight: u
    }, y.style);
    var m = d ? f : y;
    return o.default.createElement("svg", c({
      x: r || i || null,
      y: n || s || null,
      xmlns: "http://www.w3.org/2000/svg",
      width: p,
      height: u,
      viewBox: "0 0 ".concat(p, " ").concat(u)
    }, m), A({
      attributes: {},
      ex: p / 2,
      ey: u / 2,
      sx: p / 2,
      sy: u / 2,
      children: t
    }));
  };
  Te.displayName = "Svg";
  var Re = ["children"];
  function Ae(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function qe(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ae(Object(r), !0).forEach(function (t) {
        y(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ae(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  var Le = function Le(e) {
    var t = e.children,
      r = e.id,
      n = e.refX,
      i = e.refY,
      c = e.markerWidth,
      s = e.markerHeight,
      a = e.orient,
      p = void 0 === a ? "auto-start-reverse" : a,
      h = e.markerUnits,
      u = void 0 === h ? "userSpaceOnUse" : h;
    return o.default.createElement("defs", null, o.default.createElement("marker", {
      id: r,
      markerWidth: c,
      markerHeight: s,
      refX: n,
      refY: i,
      orient: p,
      markerUnits: u
    }, t));
  };
  Le.displayName = "Marker";
  var ze = ["id", "color", "markerStyle"];
  function $e(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var Ie = function Ie(e) {
    var t = e.id,
      r = e.color,
      n = void 0 === r ? "#000" : r,
      i = e.markerStyle,
      s = void 0 === i ? {} : i,
      a = P(e, ze),
      p = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? $e(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $e(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        fill: "none",
        stroke: n
      }, s);
    return o.default.createElement(Le, {
      id: t,
      markerWidth: 10,
      markerHeight: 11,
      refX: 8,
      refY: 5
    }, o.default.createElement(oe, c({
      points: [[0, 0], [8, 5], [0, 10]],
      style: p
    }, a)));
  };
  Ie.displayName = "MarkerArrow";
  var He = ["id", "color", "markerStyle"];
  function We(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var Ne = function Ne(e) {
    var t = e.id,
      r = e.color,
      n = void 0 === r ? "#000" : r,
      i = e.markerStyle,
      s = void 0 === i ? {} : i,
      a = P(e, He),
      p = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? We(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : We(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        fill: n,
        stroke: "none"
      }, s);
    return o.default.createElement(Le, {
      id: t,
      markerWidth: 10,
      markerHeight: 11,
      refX: 7,
      refY: 5
    }, o.default.createElement(oe, c({
      points: [[0, 0], [8, 5], [0, 10]],
      style: p
    }, a)));
  };
  Ne.displayName = "MarkerTriangle";
  var Xe = ["id", "size", "color", "markerStyle"];
  function Qe(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var _e = function _e(e) {
    var t = e.id,
      r = e.size,
      n = void 0 === r ? 10 : r,
      i = e.color,
      s = void 0 === i ? "#000" : i,
      a = e.markerStyle,
      p = void 0 === a ? {} : a,
      h = P(e, Xe),
      u = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Qe(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qe(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        stroke: s
      }, p);
    return o.default.createElement(Le, {
      id: t,
      markerWidth: h.strokeWidth || 1,
      markerHeight: n,
      refX: 0,
      refY: n / 2
    }, o.default.createElement(oe, c({
      points: [[0, 0], [0, n]],
      style: u
    }, h)));
  };
  _e.displayName = "MarkerLine";
  var Ue = ["id", "size", "color", "markerStyle"];
  function Be(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var Ye = function Ye(e) {
    var t = e.id,
      r = e.size,
      n = void 0 === r ? 10 : r,
      i = e.color,
      s = void 0 === i ? "#000" : i,
      a = e.markerStyle,
      p = void 0 === a ? {} : a,
      h = P(e, Ue),
      u = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Be(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Be(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        fill: s
      }, p);
    return o.default.createElement(Le, {
      id: t,
      markerWidth: 2 * n,
      markerHeight: 2 * n,
      refX: n / 2,
      refY: n / 2
    }, o.default.createElement(oe, c({
      points: [[0, 0], [n, 0], [n, n], [0, n]],
      style: u
    }, h)));
  };
  Ye.displayName = "MarkerSquare";
  var Fe = function Fe() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" == e ? t : 3 & t | 8).toString(16);
      });
    },
    Ke = ["path", "children", "id"],
    Ve = ["sx", "sy", "ex", "ey", "text", "markerId", "color", "precision", "markerEnd", "markerStart", "markers", "dotted", "scale", "scaleUnit", "rectStyle"];
  function Ge(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  var Je = function Je(e) {
      switch (e) {
        case "arrow":
          return Ie;
        case "square":
          return Ye;
        case "triangle":
          return Ne;
        case "line":
          return _e;
        default:
          return null;
      }
    },
    Ze = function Ze(e) {
      var t = e.sx,
        r = e.sy,
        n = e.ex,
        i = e.ey,
        s = e.text,
        a = e.markerId,
        p = void 0 === a ? "" : a,
        h = e.color,
        u = void 0 === h ? "#000" : h,
        l = e.precision,
        d = void 0 === l ? 0 : l,
        f = e.markerEnd,
        m = e.markerStart,
        g = e.markers,
        b = e.dotted,
        x = void 0 !== b && b,
        v = e.scale,
        O = void 0 === v ? null : v,
        w = e.scaleUnit,
        j = void 0 === w ? "" : w,
        S = e.rectStyle,
        E = void 0 === S ? {} : S,
        k = P(e, Ve),
        C = p ? "".concat(p, "-marker-start") : Fe(),
        D = p ? "".concat(p, "-marker-end") : Fe(),
        M = function (e, t, r, n, o) {
          var i = e - r,
            c = t - n;
          return Math.sqrt(i * i + c * c).toFixed(o);
        }(t, r, n, i, d),
        T = s || (O ? "".concat((M * O).toFixed(d)).concat(j) : "".concat(M, "px")),
        R = {
          width: 10 * T.length,
          height: 20,
          ox: -(n - t) / 2,
          oy: -(i - r) / 2
        },
        A = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ge(Object(r), !0).forEach(function (t) {
              y(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ge(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }
          return e;
        }({
          fill: "#fff",
          stroke: "none",
          strokeWidth: "none"
        }, E),
        q = f || g,
        L = m || g,
        z = Je(L),
        $ = Je(q);
      return o.default.createElement(o.default.Fragment, null, L && z && o.default.createElement(z, {
        color: u,
        size: "line" === L ? 20 : 10,
        id: C
      }), q && $ && o.default.createElement($, {
        color: u,
        size: "line" === q ? 20 : 10,
        id: D
      }), o.default.createElement(de, c({
        style: {
          vectorEffect: "non-scaling-stroke",
          shapeRendering: "geometricPrecision",
          stroke: u
        },
        sx: t,
        sy: r,
        ex: n,
        ey: i,
        markerStart: "url(#".concat(C, ")"),
        markerEnd: "url(#".concat(D, ")"),
        strokeDasharray: x ? "2" : null
      }, k), o.default.createElement(ce, c({}, R, {
        style: A
      }), o.default.createElement(Se, {
        fontSize: "75%",
        dominantBaseline: "middle",
        textAnchor: "middle",
        dy: 1,
        fill: u
      }, T))));
    };
  Ze.displayName = "Distance";
  var et = J,
    tt = ee,
    rt = Z,
    nt = te,
    ot = re,
    it = ne,
    ct = oe,
    st = ie,
    at = ce,
    pt = se,
    ht = ae,
    ut = pe,
    lt = he,
    dt = ue,
    yt = le,
    ft = de,
    mt = ye,
    gt = fe,
    bt = me,
    xt = ge,
    vt = be,
    Ot = xe,
    wt = ve,
    Pt = Oe,
    jt = we,
    St = Pe;
  e.Arc = mt, e.Circle = et, e.Cross = xt, e.Cubic = gt, e.Distance = Ze, e.Ellipse = tt, e.Group = function (e) {
    var t = e.children,
      r = e.sx,
      n = e.sy,
      i = e.cx,
      c = e.cy,
      s = e.ex,
      a = e.ey,
      p = P(e, Ee);
    return o.default.createElement("g", p, o.default.Children.map(t, function (e, t) {
      return o.default.cloneElement(e, function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ke(Object(r), !0).forEach(function (t) {
            y(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ke(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        key: t,
        sx: r,
        sy: n,
        cx: i,
        cy: c,
        ex: s,
        ey: a
      }, e.props));
    }));
  }, e.Kite = rt, e.Lens = nt, e.Line = ft, e.MarkerArrow = Ie, e.MarkerLine = _e, e.MarkerSquare = Ye, e.MarkerTriangle = Ne, e.Omino = St, e.PathMerge = function (e) {
    var t = e.children,
      r = P(e, Re),
      n = o.default.Children.map(t, function (e) {
        return o.default.cloneElement(e, qe(qe({
          merge: "true"
        }, r), e.props));
      }),
      s = i.default.renderToStaticMarkup(n).split("<path").map(function (e) {
        return e.includes("d=") ? function (e) {
          return e && e.includes("d=") && / d="([^"]*)"/.exec(e)[1];
        }(e) : e;
      }).filter(function (e) {
        return e;
      }),
      a = D(r);
    return o.default.createElement("path", c({
      d: s.join("")
    }, a));
  }, e.Polygon = ot, e.Polygram = it, e.Polyline = ct, e.Quad = bt, e.RadialLines = st, e.Rect = at, e.RegPolygon = pt, e.RoundedRect = Pt, e.RoundedSquare = jt, e.Sector = ht, e.Segment = ut, e.Square = lt, e.Star = dt, e.Svg = Te, e.SymH = Ot, e.SymI = wt, e.SymX = vt, e.Text = Se, e.TextPath = function (e) {
    var t = e.path,
      r = e.children,
      n = e.id,
      i = P(e, Ke),
      s = n || Fe(),
      a = {},
      p = {},
      h = ["textLength", "startOffset", "spacing", "side", "method", "lengthAdjust", "alignmentBaseline"];
    Object.keys(i).forEach(function (e) {
      h.includes(e) ? a[e] = i[e] : p[e] = i[e];
    });
    var u = D(a),
      l = D(p);
    return o.default.createElement(o.default.Fragment, null, o.default.createElement("defs", null, o.default.isValidElement(t) ? o.default.cloneElement(t, {
      id: s
    }) : o.default.createElement("path", {
      id: s,
      d: t
    })), o.default.createElement("text", l, o.default.createElement("textPath", c({
      startOffset: 0,
      href: "#".concat(s)
    }, u), r)));
  }, e.Triangle = yt, e.default = x, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});